// extracted by mini-css-extract-plugin
module.exports = {"container":"Rd","disabled":"Sd","bgBlack":"Td","content":"Ud","countdown":"Vd","topCaption":"Wd","topHeading":"Xd","heading":"Yd","copy":"Zd"};